//
// DealerList
//

$('.address-select-country').on('change', function() {

    // Get selected country
    let addressCountryClass = '.' + this.value;

    // If address country class exists
    if ($(addressCountryClass)[0]) {

        // Scroll to first country address card
        $('html, body').animate({
            scrollTop: $(addressCountryClass + ':visible:first').offset().top - 20
        }, 300, function () {

            // Add additional class to card elements to highlight the selected country cards
            $(addressCountryClass).addClass('bg-secondary');
            setTimeout(function () {
                $('.card-address').removeClass('bg-secondary');
            }, 400);
        });
    }
});